
<template>
    <main class="container-fluid">

  <div class="page-headline m-b-20 m-t-70 align-center">
        <h1 class="headline page-headline__title m-b-20">{{ pageInfo.title }}</h1>
    </div>

    <div class="row section center-md align-center">
        <div class="col-md-12 col-xs-12">
            <p v-html="pageInfo.content"></p>
        </div>
    </div>

  </main>
</template>

<script>
export default {
  name: "Privacy",
  data() {
    return {
      pageTitle: "Loading...",
      pageInfo: {}
    };
  },
  metaInfo() {
    return {
      title: this.pageTitle,
      meta: [
        { itemprop: "name", content: this.pageInfo.meta_og_description },
        { itemprop: "description", content: this.pageInfo.meta_og_description },
        { name: "og:title", content: this.pageInfo.meta_og_title },
        { name: "og:description", content: this.pageInfo.meta_og_description },
        { name: "og:url", content: this.pageInfo.meta_url },
        { name: "og:site_name", content: this.pageInfo.meta_twitter_site },
        { name: "og:type", content: this.pageInfo.meta_og_type },
        { name: "og:image", content: this.pageInfo.meta_og_image_url },

        { name: "twitter:card", content: this.pageInfo.meta_twitter_card },
        { name: "twitter:site", content: this.pageInfo.meta_twitter_site },
        { name: "twitter:title", content: this.pageInfo.meta_twitter_title },
        {
          name: "twitter:description",
          content: this.pageInfo.meta_twitter_description
        },
        {
          name: "twitter:creator",
          content: this.pageInfo.meta_twitter_creator
        },
        { name: "twitter:image", content: this.pageInfo.meta_twitter_image_url }
      ]
    };
  },
  created() {
    this.getPageInfo();
  },
  methods: {
    getPageInfo() {
      this.$http
        .get(this.$parent.$parent.apiURL + "/Pages?id=2")
        .then(function(response) {
          this.pageInfo = response.body;
          this.pageTitle = this.pageInfo.title;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Privacy.vue